import { useState } from "react";

interface IUnableToSaveMedicalNoteWarningPopupStateReturn {
    unableToSaveBy: string;
    unableToSaveDate: Date | null;
    setUnableToSaveMedicalNoteWarningPopupState: (userId: string, date: Date) => void;
    resetUnableToSaveMedicalNoteWarningPopupState: () => void;
}

function useUnableToSaveMedicalNoteWarningPopupState(): IUnableToSaveMedicalNoteWarningPopupStateReturn {
    const [unableToSaveBy, setUnableToSaveBy] = useState("");
    const [unableToSaveDate, setUnableToSaveDate] = useState<Date | null>(null);

    const setUnableToSaveMedicalNoteWarningPopupState = (userId: string, date: Date): void => {
        setUnableToSaveBy(userId);
        setUnableToSaveDate(date);
    };

    const resetUnableToSaveMedicalNoteWarningPopupState = (): void => {
        setUnableToSaveBy("");
        setUnableToSaveDate(null);
    };

    return {
        unableToSaveBy,
        unableToSaveDate,
        setUnableToSaveMedicalNoteWarningPopupState,
        resetUnableToSaveMedicalNoteWarningPopupState
    };
}

export default useUnableToSaveMedicalNoteWarningPopupState;
